import {Component, Input} from '@angular/core';

@Component({
	selector: 'shift',
	template: `
    <div class="shiftCard">
      <div class="shiftRow qo-flex-row">
        <div class="shiftDetailsDiv" style="margin: 0px 8px; min-width: unset;">
          <div class="shiftDetails" style="font-weight: bold;line-height: 25px;font-size: 25px;">{{shift.start.localDate.format('DD')}}</div>
          <div class="shiftDetails" style="font-size: 16px;line-height: 16px;">{{shift.start.localDate.format('MMM')}}.</div>
        </div>
        <div class="shiftDetailsDiv">
          <div class="shiftDetails">{{shift.start.format('LT')}} - {{shift.end.format('LT')}}</div>
          <div class="shiftDetails" *ngIf="ownShift" [class.groupDeleted]="shift.group.deleted_at">{{shift.group.group_name}}</div>
          <div class="shiftDetails" *ngIf="!ownShift"
             [class.userDeleted]="shift.user.deleted_at || shift.user.deactivated_at">{{shift.user.getFullName()}}</div>
        </div>
      </div>
      <ng-container *ngIf="showAction">
        <div class="textCenter noMargin"
           *ngIf="user.permission_level === 1 && shift.user.id != user.id && shift.public_shift_stock_id != null && !shift.bid_on_shift">
          {{ 'SHIFT.BID_ON_SHIFT' | translate }}
        </div>
        <div class="textCenter noMargin"
           *ngIf="user.permission_level === 1 && shift.user.id == user.id && shift.public_shift_stock_id != null && !shift.bid_on_shift">
          {{ 'SHIFT.REMOVE_FROM_SHIFT_STOCK' | translate }}
        </div>
        <div class="textCenter noMargin"
           *ngIf="user.permission_level === 1 && shift.public_shift_stock_id != null && shift.bid_on_shift">
          {{ 'SHIFT.REMOVE_BID_ON_SHIFT' | translate }}
        </div>
      </ng-container>
    </div>
	`,
})
export class ShiftComponent {
	@Input() public shift;
	@Input() public ownShift = false;
	@Input() public  user;
	@Input() public showAction = true;
}
